<template>
    <div id="news" class="grid-container">
        <ul id="instafeed" class="feed_article--holder grid-x">
            <li v-show="feedsReady" class="cell small-6 large-3" v-for="column in storeFeed" :key="column.id">
                <ul class="grid-x">
                    <li class="cell small-12" v-for="feed in column" :key="feed.id">
                        <instagram-item :feed="feed"></instagram-item>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="button_more--holder">
            <a href="https://www.instagram.com/netemosametemo_movie/" class="button_more" title="Instagram" target="_blank">
                <svg class="icon icon-instagram"><use xlink:href="#icon-instagram"></use></svg>Instagram
            </a>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Instafeed from 'instafeed.js'
import InstagramItem from '@/components/InstagramItem'

Vue.component('instagram-item', InstagramItem)
export default {
    name: 'instagram',
    components: {
        Instafeed
    },
    data () {
        return {
            feed: null,
            feedsReady: false,
            isDesktop: false,
            instaToken: '7416055937.1677ed0.7c0f717c036842ffb0747eea1e1bbd1f',
            feedsArray: {
                feed0: [],
                feed1: []
            },
            feedLimit: 8,
            feedsCols: 2,
            loadButtonActive: true
        }
    },

    created () {
        this.initSort()
        this.fetchData()
    },

    computed: {
        buttonMoreClass: function () {
            if (this.loadButtonActive) {
                return 'button_more'
            } else {
                return 'button_more disabled'
            }
        },
        storeFeed: function () {
            console.log(this.$store.state.feeds)

            return this.$store.state.feeds
        }
    },

    methods: {
        fetchData: function () {
            let self = this
            this.feed = new Instafeed({
                get: 'user',
                clientId: '67d4ff4151ab45018192e104f7c5b596',
                userId: '7416055937',
                template: '',
                limit: this.feedLimit,
                accessToken: this.instaToken,
                success: function (response) {
                    self.sortData(response.data)
                    self.feedsReady = true
                },
                error: function (error) {
                    console.log(error)
                },
                after: function () {
                    if (!this.hasNext()) {
                        self.loadButtonActive = false
                    }
                }
            })
            this.feed.run()
        },

        initSort: function () {
            if (window.matchMedia('(min-width: 1024px)').matches) {
                this.feedsCols = 4
                this.isDesktop = true
                this.feedsArray = {
                    feed0: [],
                    feed1: [],
                    feed2: [],
                    feed3: []
                }
            }

            this.$store.commit('initFeeds', this.feedsArray)
        },

        sortData: function (data) {
            // init
            let j = 0

            // sort data
            for (let i = 0; i < data.length; i++) {
                if (j >= this.feedsCols) { j = 0 }
                switch (j) {
                case 0:
                    this.feedsArray.feed0.push(data[i])
                    break
                case 1:
                    this.feedsArray.feed1.push(data[i])
                    break
                case 2:
                    this.feedsArray.feed2.push(data[i])
                    break
                case 3:
                    this.feedsArray.feed3.push(data[i])
                    break
                }
                j++
            }
            this.$store.commit('addFeeds', this.feedsArray)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Instagram.vue